import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import classNames from "classnames";
import classnames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button, Row } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import InfoMessage from "../common/InfoMessage";
import Loader from "../common/Loader";
import ScopeType from "../../app/models/search";
import moment from "moment";
import { toast } from "react-toastify";

import ProtectedDownloadCustom from "../common/ProtectedDownloadCustom";


interface IParams {
  handleActionDownload : (filename: string, href: string) => void;
  

}


const SearchResults: React.FC<IParams> = ({handleActionDownload}) => {
  const rootStore = useContext(RootStoreContext);
  const { searching, searchResults, selectedSearchPage, setSelectedSearchPage ,setStoredSearchResults} = rootStore.playerStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["features", "dateCustom"], translationHookOptions);
  const pageItems = 10;
  const {isMobileMediaQuery} = rootStore.responsiveStore;
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    
  // serve se ha cliccato fuori dalla searchResultContainer
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    const scrollableElement = document.querySelector(".searchResultContainer");
    if (scrollableElement) disableBodyScroll(scrollableElement);
   
   
    return () => {
      const scrollableElement = document.querySelector(
        ".searchResultContainer"
      );
      if (scrollableElement) enableBodyScroll(scrollableElement);
    };
  });
  // serve se ha cliccato fuori dalla searchResultContainer
  const handleClickOutside = (event: Event) => {
    if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
      setStoredSearchResults(false);
    }
  };

  if (searching) return <Loader />;

  return (
    <>
      {searchResults ? (
        <>
          {searchResults.count > 0 ? (
            <>
              <div
                className={classnames(isMobileMediaQuery ?"numSearchResultsMobile" : "numSearchResults"," text-white bg-dark")}
              >
                {t("search_page_results_label")} {searchResults.count}
              </div>
              <div className="py-2 px-2 searchResultContainer" ref={containerRef}>
                {searchResults.results
                  .slice(selectedSearchPage * pageItems, selectedSearchPage * pageItems + pageItems)
                  .map((r, index) => (

                    <>
                    
                    {r.scope === ScopeType.ARCHIVE && r.typology==0 ? (<>
                     
                  
                      <div key={index} className="my-3 searchElement d-flex justify-content-between align-items-center">
                  
                      <div>
                  <strong className="searchResText searchResTitle text-truncate">
                    [{t(r.scope).toUpperCase()}]  &nbsp;
                    {r.scope === ScopeType.ODG && (<>
                       {r.meetingTitle.toUpperCase()}  ({moment(r.startMeeting).format("DD/MM/YYYY HH:mm")})
                       </>)}
                    {r.scope===ScopeType.ARCHIVE && (<>
                        {r.archiveTitle.toUpperCase()} 
                       </>)
                    }
                 </strong>
                    <strong className="searchResText searchResTitle text-truncate">
                    ({t("Title")})  {r.title} 
                    </strong>
                    {r.caption && (
                      <span className="searchResText searchResCaption text-truncate align-middle">
                        - {r.caption}
                      </span>
                    )}
                  </div>
                {/* Bottone a destra */}
                   <div>
                    <ProtectedDownloadCustom
                      hasLoaderModal={true}
                      sourceType={"archive"} 
                      sourceId={r.sourceId} 
                      contentId={r.contentId}
                      handleActionDownload={handleActionDownload}
                    >
                      <Button
                        id={`btnNodeDownload_${index}`}
                        className="btn-icon-only btn node-context"
                        color={theme!.buttonColor}
                      >
                        <span className="btn-inner--icon">
                          <i className="fas fa-download fa-lg"></i>
                        </span>
                      </Button>
                    </ProtectedDownloadCustom>
                  </div>
                  </div>
                    
                    
                    
                    </>): (
                    <>
                    
                      <div key={index} className="my-3 searchElement">
                  
                      <Link to={r.link} style={{lineHeight:"1"}}  onClick={()=> { setStoredSearchResults(true)}}>
                      <strong className="searchResText searchResTitle text-truncate">
                        [{t(r.scope).toUpperCase()}]  &nbsp;
                        {r.scope === ScopeType.ODG && (<>
                           {/* {r.meetingTitle.toUpperCase()}  (  {moment(r.startMeeting).format("DD/MM/YYYY HH:mm")} ) */}
                           {r.meetingTitle.toUpperCase()}  {" "}
                           ({t("datetime", {
                                      ns:"dateCustom",
                                      day: moment(r.startMeeting).format("DD"),
                                      month: moment(r.startMeeting).format("MM"),
                                      year: moment(r.startMeeting).format("YYYY"),
                                      hour24: moment(r.startMeeting).format("HH"),
                                      hour12: moment(r.startMeeting).format("hh"),
                                      minute: moment(r.startMeeting).format("mm"),
                                      ampm: moment(r.startMeeting).format("A")
                                  })}
                               )
                           </>)}
                        {r.scope===ScopeType.ARCHIVE && (<>
                            {r.archiveTitle.toUpperCase()} 
                           </>)
                        }
                     </strong>
                        <strong className="searchResText searchResTitle text-truncate">
                        ({t("Title")})  {r.title} 
                        </strong>
                        {r.caption && (
                          <span className="searchResText searchResCaption text-truncate align-middle">
                            - {r.caption}
                          </span>
                        )}
                      </Link>
                    </div>
                    

                    
                    </>)}

                   
                    </>
                  ))}
              </div>
              <Row className="float-right mt-1 mr-2">
                <Button
                  id={`btnPrevPage`}
                  className={classNames(
                    "searchPagesBtn btn-icon-only btn",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${theme!.buttonTextColor}`
                  )}
                  type="button"
                  disabled={selectedSearchPage <= 0}
                  onClick={() => setSelectedSearchPage(selectedSearchPage - 1)}
                >
                  <span className="btn-inner--icon">
                    <i className="fas fa-step-backward" />
                  </span>
                </Button>

                <div className="numSearchPages">
                  Pag. {selectedSearchPage + 1} /{" "}
                  {Math.ceil(searchResults.count / pageItems)}
                </div>

                <Button
                  id={`btnNextPage`}
                  className={classNames(
                    "searchPagesBtn btn-icon-only btn",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${theme!.buttonTextColor}`
                  )}
                  type="button"
                  disabled={
                    selectedSearchPage >= Math.ceil(searchResults.count / pageItems) - 1
                  }
                  onClick={() => setSelectedSearchPage(selectedSearchPage + 1)}
                >
                  <span className="btn-inner--icon">
                    <i className="fas fa-step-forward" />
                  </span>
                </Button>
              </Row>
            </>
          ) : (
            <InfoMessage
              icon="fa fa-exclamation-circle fa-3x"
              color={theme!.infoMessageColor}
              message={t("search_page_empty_results")}
            />
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default observer(SearchResults);
